export const ANALYSIS_COMMAND_NAME = Object.freeze({
    PREFLIGHT_RUN: 'preflightRun',
    EXECUTE_RUN_FROM_PENDING_CONTEXT: 'executeRunFromPendingContext',
    DISPATCH_AI_IF_NEEDED: 'dispatchAiIfNeeded',
    POLL_AI_JOB: 'pollAiJob',
    REFRESH_SUBJECT: 'refreshSubject',
    QUOTE_CAPABILITY_UNLOCK: 'quoteCapabilityUnlock',
    EXECUTE_CAPABILITY_UNLOCK: 'executeCapabilityUnlock',
    QUOTE_AND_UNLOCK_CAPABILITIES: 'quoteAndUnlockCapabilities',
    QUOTE_AND_UPGRADE_RESULT: 'quoteAndUpgradeResult',
    QUOTE_UPGRADE_RESULT: 'quoteUpgradeResult',
    EXECUTE_UPGRADE_RESULT: 'executeUpgradeResult'
});

export const ANALYSIS_GATEWAY_ENDPOINT = Object.freeze({
    REFERENCE_CATALOGS: '/analysis/reference-catalogs/',
    CAPABILITY_CATALOGS: '/analysis/capability-catalogs/',
    QUOTES: '/analysis/quotes/',
    RUN_ASSET_RESOLUTIONS: '/analysis/run-asset-resolutions/',
    RUN_ASSET_UPLOAD_AUTHORIZATIONS: '/analysis/run-asset-upload-authorizations/',
    RUNS: '/analysis/runs/',
    AI_JOBS: '/analysis/ai-jobs/',
    SUBJECTS: '/analysis/subjects/',
    CAPABILITY_UNLOCKS: '/analysis/capability-unlocks/',
    AI_RESULT_UPGRADES: '/analysis/ai-result-upgrades/',
    PAYMENTS_STATUS: '/payments/status/'
});

export const ANALYSIS_LEGACY_BOUNDARY = Object.freeze({
    HASH_PRESET_SCOPE: 'legacy-only',
    RELATION_GATEWAY: 'legacy-only',
    UPLOAD_DEFAULT_CHARGE_FLOW: 'legacy-only'
});
